import $ from 'jquery';

export function loadMore() {
  let postPage = 1;
  let productPage = 1;
  let applicationPage = 1;
  const $loadButton = $('.load-more-posts');
  let searchParams = new URLSearchParams(window.location.search);
  let searchTerm = searchParams.get('s');

  $loadButton.each(function () {
    const $resultsContainer = $(this).parent().parent();
    const $noResults = $resultsContainer.find('.tease').length === 0;

    if ($noResults) {
      $(this).parent().remove();
      $resultsContainer.append('<p>No Results</p>');
    }

    $(this).on('click', function (e) {
      e.preventDefault();
      const $postType = $(this).data('post-type');
      let $target = $(this);
      let page;

      switch ($postType) {
        case 'post':
          postPage++;
          page = postPage;
          break;
        case 'product':
          productPage++;
          page = productPage;
          break;
        case 'application':
          applicationPage++;
          page = applicationPage;
          break;
      }

      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
          action: 'get_more',
          get_page: page,
          s: searchTerm,
          post_type: $postType,
        },
        success: function (data) {
          if ($('<div></div>').html(data).find('.ended').length > 0)
            $($target).parents('.results__cta').remove();
          else $($target).parents('.results__cta').show();
          $(`.${$postType}-results__container`).append(data);
        },
        error: function (data) {
          console.log(data);
        },
      });
    });
  });
}
